import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PRICE, PRODUCT, trustBadges } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="oferta-final" className="border-y border-line bg-canvasAlt" data-id="element-69" data-mp="c4fu2fmwmpo6">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16 text-center" data-id="element-70" data-mp="m4ymhysjbehp">
        <Reveal className="rounded-3xl border-2 border-gold-bright bg-surface p-7 md:p-10" data-id="element-71" data-mp="m2vjme6a9qvk">
          <h2 id="oferta-final" className="font-display text-2xl md:text-3xl font-bold uppercase leading-tight text-ink" data-id="element-72" data-mp="h5lqanfrwv2g">
            {PRODUCT}
          </h2>
          <p className="mt-2 text-sm font-bold uppercase tracking-[0.2em] text-gold" data-id="element-73" data-mp="qwglihazz501">
            6 Módulos + 5 Bonos gratis
          </p>

          <p className="mt-6 text-sm font-semibold uppercase tracking-[0.14em] text-ink-muted" data-id="element-74" data-mp="zwmxtzuylyxm">
            Valor de los bonos{' '}
            <span className="line-through decoration-danger" data-id="element-75" data-mp="2c5puvpiev1zj">
              {BONUS_VALUE}
            </span>{' '}
            → hoy: $0
          </p>

          <p className="mt-5 text-xs font-bold uppercase tracking-[0.28em] text-ink-subtle" data-id="element-76" data-mp="2m2ua15du9x6u">
            Llevate todo por
          </p>
          <p className="mt-2 flex items-baseline justify-center gap-2" data-id="element-77" data-mp="2r2768gqlogm3">
            <span className="font-display text-6xl font-bold text-ink" data-id="element-78" data-mp="2v3sfzt7u8es2">
              {PRICE}
            </span>
            <span className="text-xl font-semibold text-ink-muted" data-id="element-79" data-mp="3023o9zihih86">ARS</span>
          </p>
          <p className="mt-1 text-xs font-bold uppercase tracking-[0.3em] text-gold" data-id="element-80" data-mp="34tltx0vgd5zh">
            Pago único
          </p>

          <div className="mt-7 flex justify-center" data-id="element-81" data-mp="39rdhxjsz87ye">
            <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-82" data-mp="39u9fv84tqwmu">
              Quiero empezar hoy + recibir mis bonos
            </CtaButton>
          </div>

          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-ink-muted" data-id="element-83" data-mp="3itwj7zh46cij">
            {trustBadges.map(badge => <li key={badge} className="flex items-center gap-1.5" data-id="element-84" data-mp="1epigdfbk1he0">
                <CheckIcon size={13} className="flex-shrink-0 text-cta" strokeWidth={3} data-id="element-85" data-mp="1en5rei7dq6rg" />
                {badge}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}